export const NO_DESCRIPTION_AVAILABLE = "No Description Available";
